import React from 'react';
import Icon from '@mdi/react';
import { Button, Tooltip } from 'antd';
import {
  mdiMagnify,
  mdiAccountMultiplePlus,
  mdiLinkVariant,
  mdiFilterOutline,
  mdiLinkPlus,
} from '@mdi/js';
import Ninja from '@ninja';
import useQueryParams from 'hooks/useQueryParams';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import P from 'router/paths';

const channels = {
  facebook: {
    title: 'Meta',
    icon: '/icons/networks/facebook.svg',
  },
  google: {
    title: 'Google',
    icon: '/icons/networks/google.svg',
  },
  bing: {
    title: 'Bing',
    icon: '/icons/networks/bing.svg',
  },
  seo: {
    title: 'SEO',
    icon: <Icon path={mdiMagnify} size={0.8} color={Ninja.colors.medium} />,
  },
  referral: {
    title: 'Referral',
    icon: <Icon path={mdiAccountMultiplePlus} size={0.8} color={Ninja.colors.medium} />,
  },
  custom_urls: {
    title: 'Custom URLs',
    icon: <Icon path={mdiLinkPlus} size={0.8} color={Ninja.colors.medium} />,
  },
  direct: {
    title: 'Direct',
    icon: <Icon path={mdiLinkVariant} size={0.8} color={Ninja.colors.medium} />,
  },
};

const ChannelsFormatter = ({ channel, showTitle = true, showFilterIcon = true }) => {
  const { setUrlParams } = useQueryParams();
  const history = useHistory();

  if (!channel) return '-';

  const data = channels[channel.toLowerCase()];
  if (!data) return '-';

  const handleFilterClick = (e) => {
    history.push(P.CRM.DEALS);
    setUrlParams({ channels: [channel] });
  };

  return (
    <div className='flex items-center gap-1'>
      {showFilterIcon && (
        <Tooltip
          placement='top'
          title={`Filter by ${data.title}`}
          destroyTooltipOnHide
          mouseEnterDelay={0.1}
        >
          <Button size='small' type='text' onClick={handleFilterClick}>
            <Icon path={mdiFilterOutline} size={0.6} color={Ninja.colors.medium} />
          </Button>
        </Tooltip>
      )}
      <Tooltip
        placement='top'
        title={!showTitle && data.title}
        destroyTooltipOnHide
        mouseEnterDelay={0.1}
      >
        <span className='flex items-center gap-1'>
          {typeof data.icon === 'string' ? (
            <img src={data.icon} alt={data.title} className='w-4 h-4' />
          ) : (
            data.icon
          )}
          {showTitle && <span>{data.title}</span>}
        </span>
      </Tooltip>
    </div>
  );
};

export default ChannelsFormatter;
